// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1sAQe","content":"LayoutSettings_content__3O_6p"};